import { HttpEvent, HttpRequest } from '@angular/common/http';
import { inject, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AuthFacade } from '@lentau/auth/store/store/auth.facade';
import { REQUEST_STATE } from '@lentau/ui-kit/core/enums/request-state.enum';
import { isAuthTokenExperiment } from '@lentau/auth/shared/experiment';

export function handleTokenWaitInterceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  const authFacade: AuthFacade = inject(AuthFacade);
  const isATE: Signal<boolean> = isAuthTokenExperiment();

  if (!req.url.includes('/auth/') && isATE()) {
    const expiresIn: Date = authFacade.tokenExpiresIn();
    if (expiresIn && !authFacade.tokenIsLoading()) {
      const expiresTimeout: number = expiresIn.getTime() - new Date().getTime();

      if (expiresTimeout < 10000) authFacade.refreshPassportToken();
    }

    return authFacade.tokenRequestState$.pipe(
      // Обсервейбл меняется с задержкой сигнал уже принял значение, а обсервейбл нет
      filter(() => authFacade.tokenRequestState() !== REQUEST_STATE.LOADING),
      take(1),
      switchMap(() => next(req))
    );
  } else {
    return next(req);
  }
}
